module.exports = __webpack_public_path__ + "img/MOBILE_Slide3.8675e62d.png";